import React from "react";
import { Link } from "react-router-dom";

export default function PrivacyPolicy() {
    return(
        <React.Fragment>
            <div className="page-title parallax parallax1 ">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="page-title-content text-center">
                                    <div className="breadcrumbs">
                                        <ul>
                                            <li><Link to="/">Home</Link></li>
                                            <li className="blog"><a href="#">Privacy Policy</a></li>
                                        </ul>
                                    </div>
                                    <div className="page-title-heading">
                                        <h2 className="title"><a href="#">Privacy Policy</a></h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            </div>
            <div className="main-about">
                <section className="flat-about-us">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 col-md-12">
                                <div className="about-us-border">
                                    <p className="content-about">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugia: nulla pariatu: Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciats unde omnis iste natus error sit voluptatem accusantium doloremque laudartiura.</p>
                                </div>
                            </div>
                        </div>
                    </div> 
                </section>
            </div>
        </React.Fragment>
    )
}